<template lang="pug">
    .wrapper
        router-view( v-if='noContainer' )
        v-container( fluid grid-list-lg px-5 v-else )
            v-layout( row wrap )
                v-flex( xs12 v-if='!noBreadcrumb' )
                    v-card
                        custom-breadcrumb-router( index-text='Ventas' )
                v-flex( xs12 )
                    router-view
</template>

<script>
    //
    import { RouterBreadcrumb } from '@/components/reusable_components/next'
    //
    export default {
        name: 'main',
        components: {
            'custom-breadcrumb-router': RouterBreadcrumb,
        },
        props: {

            /**
             * 
             */
            noBreadcrumb: Boolean,

            /**
             * 
             */
            noContainer: Boolean,
        },
    }
</script>